import { render, staticRenderFns } from "./InventoryComponent.vue?vue&type=template&id=16fb081b&scoped=true"
import script from "./InventoryComponent.js?vue&type=script&lang=js&external"
export * from "./InventoryComponent.js?vue&type=script&lang=js&external"
import style0 from "./InventoryComponent.vue?vue&type=style&index=0&id=16fb081b&prod&lang=scss&scoped=true"
import style1 from "./InventoryComponent.vue?vue&type=style&index=1&id=16fb081b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fb081b",
  null
  
)

export default component.exports